export var FILTER_GROUP_NAME_CHANGE = 'FILTER_GROUP_NAME_CHANGE';
export var FILTER_GROUP_SAVE = 'FILTER_GROUP_SAVE';
export var FILTER_GROUP_EDIT_CANCEL = 'FILTER_GROUP_EDIT_CANCEL';